import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSparkleIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5,
	stroke: "currentColor",
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M8.45 3.85 8 2.5l-.45 1.35a7 7 0 0 1-2.7 3.58L4 8l.84.57a7 7 0 0 1 2.7 3.58L8 13.5l.45-1.35a7 7 0 0 1 2.7-3.58L12 8l-.84-.57a7 7 0 0 1-2.7-3.58Z" })
});
export default SvgSparkleIcon;
